var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import i18n from "../../../strings/i18n";
import { RegisterAccountWrap } from "./RegisterAccountButton.styles";
var RegisterAccountButton = function (_a) {
    var handleClick = _a.handleClick;
    return (_jsx(RegisterAccountWrap, __assign({ "data-reason": "register", "data-type": "register", "data-object": "button", "data-analytics": "clicktrackingevent", buttonType: "secondary", onClick: handleClick }, { children: i18n({ labels: "registerAccountBtn" }) })));
};
export default RegisterAccountButton;
//# sourceMappingURL=RegisterAccountButton.js.map